import React from 'react';
import DevSecOpsOfferPage from './DevSecOpsOfferPage';

const DevSecOpsDaily = () => (
    <DevSecOpsOfferPage
        scope="Lite"
        icon="las la-user-cog"
        summary="DevSecOps ONE Lite provides focused access to development, infrastructure, automation, and security expertise — as a one-time engagement or a recurring service."
        oneTimePrice="$929.00"
        recurringPrice="$773"
        purchaseUrl="https://my.epicfinal.com/index.php?rp=/store/managed-services/devsecops-one-daily-subscription"
        oneTimeDescription="Ideal for a focused task, fix, change, setup, or professional engagement with no ongoing commitment."
        recurringDescription="A dependable technical point of contact for focused, ongoing technology needs."
    />
);

export default DevSecOpsDaily;
